import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom'; // Outlet for nested routes
import './DashboardPage.css';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

function DashboardPage() {
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const sidebarRef = useRef(null);

  useEffect(() => {
    // Load permissions from localStorage
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions && storedPermissions !== 'undefined') {
      try {
        const parsedPermissions = JSON.parse(storedPermissions);
        if (Array.isArray(parsedPermissions)) {
          setPermissions(parsedPermissions);
        } else if (typeof parsedPermissions === 'string') {
          setPermissions(JSON.parse(parsedPermissions));
        } else {
          console.error('Permissions are not in the expected format:', parsedPermissions);
        }
      } catch (error) {
        console.error('Error parsing permissions:', error);
      }
    }
  }, []);

  const handleToggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible); // Toggle the sidebar visibility
  };

  const handleLinkClick = () => {
    setSidebarVisible(false); // Close sidebar when a link is clicked
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarVisible(false); // Close sidebar if clicked outside
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('permissions');
    window.location.href = '/'; // Redirect to login page
  };

  useEffect(() => {
    if (isSidebarVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarVisible]);

  return (
    <div className="dashboard-page mt-5">
      <div className="main-content">
        <div ref={sidebarRef} className={`sidebar ${isSidebarVisible ? 'visible' : ''}`}>
          <Sidebar onLinkClick={handleLinkClick} permissions={permissions} />
        </div>
        <div className="content-area">
          <Header onToggleSidebar={handleToggleSidebar} onLogout={handleLogout} />
          <div className="content-body">
            <Outlet key={window.location.pathname} />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
